import AddIntialDocuments from "./add-intial-documents";

export default AddIntialDocuments;
